import ScrollAnimation from 'react-animate-on-scroll';

import 'animate.css/animate.compat.css';

const FadeInAnimation = (props) => {
  const { offset, delay = 250, children } = props;
  return (
    <ScrollAnimation animateIn='fadeInUp' offset={offset} delay={delay} animateOnce {...props}>
      {children}
    </ScrollAnimation>
  );
};

export default FadeInAnimation;
